'use client';

import { useState } from 'react';
import Link from 'next/link';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { BIBLE_BOOKS } from '@/lib/constants';

interface BookListProps {
  activeBook?: string;
}

export default function BookList({ activeBook }: BookListProps) {
  const [otOpen, setOtOpen] = useState(true);
  const [ntOpen, setNtOpen] = useState(true);

  const otBooks = BIBLE_BOOKS.filter((b) => b.testament === 'old');
  const ntBooks = BIBLE_BOOKS.filter((b) => b.testament === 'new');

  return (
    <div className="space-y-2">
      {/* Old Testament */}
      <div>
        <button
          onClick={() => setOtOpen(!otOpen)}
          className="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg transition-colors hover:bg-white/5"
        >
          {otOpen ? (
            <ChevronDown size={14} style={{ color: 'var(--accent-gold)' }} />
          ) : (
            <ChevronRight size={14} style={{ color: 'var(--text-secondary)' }} />
          )}
          <span
            className="text-xs font-semibold uppercase tracking-wider"
            style={{ color: 'var(--text-secondary)' }}
          >
            Old Testament
          </span>
          <span
            className="text-xs ml-auto"
            style={{ color: 'rgba(160, 152, 128, 0.5)' }}
          >
            {otBooks.length}
          </span>
        </button>
        {otOpen && (
          <div className="ml-2 space-y-0.5">
            {otBooks.map((book) => (
              <Link
                key={book.name}
                href={`/reader/${encodeURIComponent(book.name)}`}
                className="block text-sm px-3 py-1.5 rounded-lg transition-colors"
                style={{
                  backgroundColor:
                    activeBook === book.name
                      ? 'rgba(200, 164, 94, 0.12)'
                      : 'transparent',
                  color:
                    activeBook === book.name
                      ? 'var(--accent-gold)'
                      : 'var(--text-secondary)',
                }}
              >
                {book.name}
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* New Testament */}
      <div>
        <button
          onClick={() => setNtOpen(!ntOpen)}
          className="flex items-center gap-2 w-full text-left px-3 py-2 rounded-lg transition-colors hover:bg-white/5"
        >
          {ntOpen ? (
            <ChevronDown size={14} style={{ color: 'var(--accent-gold)' }} />
          ) : (
            <ChevronRight size={14} style={{ color: 'var(--text-secondary)' }} />
          )}
          <span
            className="text-xs font-semibold uppercase tracking-wider"
            style={{ color: 'var(--text-secondary)' }}
          >
            New Testament
          </span>
          <span
            className="text-xs ml-auto"
            style={{ color: 'rgba(160, 152, 128, 0.5)' }}
          >
            {ntBooks.length}
          </span>
        </button>
        {ntOpen && (
          <div className="ml-2 space-y-0.5">
            {ntBooks.map((book) => (
              <Link
                key={book.name}
                href={`/reader/${encodeURIComponent(book.name)}`}
                className="block text-sm px-3 py-1.5 rounded-lg transition-colors"
                style={{
                  backgroundColor:
                    activeBook === book.name
                      ? 'rgba(200, 164, 94, 0.12)'
                      : 'transparent',
                  color:
                    activeBook === book.name
                      ? 'var(--accent-gold)'
                      : 'var(--text-secondary)',
                }}
              >
                {book.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
